
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.75 18.001A.752.752 0 010 17.25c.003-4.134 3.369-7.498 7.503-7.498a7.484 7.484 0 012.941.6.745.745 0 01.402.41.748.748 0 01-.696 1.03c-.101 0-.2-.02-.294-.06a5.964 5.964 0 00-2.349-.48 5.967 5.967 0 00-4.246 1.755A5.96 5.96 0 001.5 17.25a.751.751 0 01-.75.751zM7.5 9.751c-2.688 0-4.875-2.187-4.875-4.875S4.812.001 7.5.001s4.875 2.187 4.875 4.875S10.188 9.751 7.5 9.751zm0-8.25c-1.861 0-3.375 1.514-3.375 3.375S5.639 8.251 7.5 8.251s3.375-1.514 3.375-3.375S9.361 1.501 7.5 1.501zM17.25 23.999a6.708 6.708 0 01-4.749-1.957l-.024-.022a6.684 6.684 0 01-1.978-4.771 6.758 6.758 0 016.75-6.75c1.783 0 3.464.691 4.736 1.945l.036.031c.01.01.021.023.031.036A6.695 6.695 0 0124 17.249a6.758 6.758 0 01-6.75 6.75zm-3.142-2.549a5.239 5.239 0 003.142 1.049 5.256 5.256 0 005.25-5.25c0-1.135-.37-2.236-1.049-3.142l-7.343 7.343zm3.142-9.451a5.256 5.256 0 00-5.25 5.25c0 1.135.37 2.235 1.048 3.141l7.343-7.343a5.241 5.241 0 00-3.141-1.048z"}})])
          )
        }
      }
    